<template>
  <div class="">
    <Card class="">
      <template #title>
        <Avatar icon="pi pi-user" style="background-color: #dee9fc; color: #1a2551" shape="circle" />
        Karakteristikler
      </template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_KarakteristikModal()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="KarakteristikListesi"
          v-on:set-child-data="getDataChild" :editbutton="true" />
      </template>
    </Card>
    <!-- header="Karakteristik" -->
    <Dialog v-model:visible="KarakteristikModal" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '35vw' }" modal>
      <template #header>
        <div class="inline-flex items-center justify-center gap-2">
          <Avatar icon="pi pi-info-circle" style="background-color: #FFF9F9; color: #1a2551; cursor: pointer;"
            shape="circle" @click="this.infoGoster()" />
          <span class="font-bold whitespace-nowrap">Karakteristik</span>
        </div>
      </template>
      <div class="formgrid grid ">
        <div class="field col md:col-12">
          <label for="KarakteristikAd" class="font-bold block">Ad</label>
          <InputText id="KarakteristikAd" type="text" v-model="KarakteristikAd" :invalid="this.Valid.KarakteristikAd"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikEn" class="font-bold block">En</label>
          <InputNumber id="KarakteristikEn" v-model="KarakteristikEn" inputId="horizontal-buttons" showButtons
            buttonLayout="horizontal" :step="1" :minFractionDigits="1" :maxFractionDigits="3" fluid
            class="text-base text-color w-full">
            <template #incrementbuttonicon>
              <span class="pi pi-plus" />
            </template>
            <template #decrementbuttonicon>
              <span class="pi pi-minus" />
            </template>
          </InputNumber>
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikBoy" class="font-bold block">Boy</label>
          <InputNumber id="KarakteristikBoy" v-model="KarakteristikBoy" inputId="horizontal-buttons" showButtons
            buttonLayout="horizontal" :step="1" :minFractionDigits="1" :maxFractionDigits="3" fluid
            class="text-base text-color w-full">
            <template #incrementbuttonicon>
              <span class="pi pi-plus" />
            </template>
            <template #decrementbuttonicon>
              <span class="pi pi-minus" />
            </template>
          </InputNumber>
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikYukseklik" class="font-bold block">Yukseklik</label>
          <InputNumber id="KarakteristikYukseklik" v-model="KarakteristikYukseklik" inputId="horizontal-buttons"
            showButtons buttonLayout="horizontal" :step="1" :minFractionDigits="1" :maxFractionDigits="3" fluid
            class="text-base text-color w-full">
            <template #incrementbuttonicon>
              <span class="pi pi-plus" />
            </template>
            <template #decrementbuttonicon>
              <span class="pi pi-minus" />
            </template>
          </InputNumber>
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikDerinlik" class="font-bold block">Derinlik</label>
          <InputNumber id="KarakteristikDerinlik" v-model="KarakteristikDerinlik" inputId="horizontal-buttons"
            showButtons buttonLayout="horizontal" :step="1" :minFractionDigits="1" :maxFractionDigits="3" fluid
            class="text-base text-color w-full">
            <template #incrementbuttonicon>
              <span class="pi pi-plus" />
            </template>
            <template #decrementbuttonicon>
              <span class="pi pi-minus" />
            </template>
          </InputNumber>
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikRenk" class="font-bold block">Renk</label>
          <InputText id="KarakteristikRenk" type="text" v-model="KarakteristikRenk"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6 mt-5">
          <div class="flex items-center">
            <label for="KarakteristikIthal" class="font-bold block mr-2">Ithal</label>
            <Checkbox id="KarakteristikIthal" v-model="KarakteristikIthal" :binary="true" />
          </div>
        </div>
        <div class="field col md:col-6">

        </div>
        <div class="field col md:col-6"></div>
        <div class="field col md:col-6">
          <label for="KarakteristikYuzey1" class="font-bold block">Yuzey 1</label>
          <InputText id="KarakteristikYuzey1" type="text" v-model="KarakteristikYuzey1"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikYuzey2" class="font-bold block">Yuzey 2</label>
          <InputText id="KarakteristikYuzey2" type="text" v-model="KarakteristikYuzey2"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikYuzey3" class="font-bold block">Yuzey 3</label>
          <InputText id="KarakteristikYuzey3" type="text" v-model="KarakteristikYuzey3"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="KarakteristikYuzey4" class="font-bold block">Yuzey 4</label>
          <InputText id="KarakteristikYuzey4" type="text" v-model="KarakteristikYuzey4"
            class="text-base text-color w-full" />
        </div>

      </div>
      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._KarakteristikModal()" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import DataTable from "../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../services/GlobalServis";

export default {
  data() {
    return {
      DataTable_render: true,
      KarakteristikListesi: [],
      columns: [
        { field: "Ad", header: "Karakteristik Adı" },
        { field: "Renk", header: "Renk" },
        { field: "En", header: "En" },
        { field: "Boy", header: "Boy" },
        { field: "Yukseklik", header: "Yukseklik" },
        { field: "Derinlik", header: "Derinlik" },
        { field: "Ambalaj,", header: "Ambalaj" },
        { field: "Ithal", header: "Ithal" },
      ],
      KarakteristikModal: false,
      KarakteristikModelDurum: null,

      Karakteristik_rowid: null,
      KarakteristikAd: "",
      KarakteristikEn: 0,
      KarakteristikBoy: 0,
      KarakteristikYukseklik: 0,
      KarakteristikDerinlik: 0,
      KarakteristikRenk: "",
      KarakteristikAmbalaj: "",
      KarakteristikIthal: false,
      KarakteristikYuzey1: "",
      KarakteristikYuzey2: "",
      KarakteristikYuzey3: "",
      KarakteristikYuzey4: "",

      //--------------
      // Validation Elements
      Valid: {
        KarakteristikAd: false,
      }
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.ResetForm();
      this.KarakteristikModal = !this.KarakteristikModal;
      this.KarakteristikModelDurum = false;
      this.Karakteristik_rowid = getdata_child.data.Karakteristik_rowid;
      let data = {
        Karakteristik_rowid: getdata_child.data.Karakteristik_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetKarakteristikInfo", data).then((res) => {
        if (res.status == 200) {

          this.KarakteristikAd = res.data[0].Ad;
          this.KarakteristikEn = res.data[0].En;
          this.KarakteristikBoy = res.data[0].Boy;
          this.KarakteristikYukseklik = res.data[0].Yukseklik;
          this.KarakteristikDerinlik = res.data[0].Derinlik;
          this.KarakteristikRenk = res.data[0].Renk;
          this.KarakteristikAmbalaj = res.data[0].Ambalaj;
          this.KarakteristikIthal = res.data[0].Ithal;
          this.KarakteristikYuzey1 = res.data[0].Yuzey1;
          this.KarakteristikYuzey2 = res.data[0].Yuzey2;
          this.KarakteristikYuzey3 = res.data[0].Yuzey3;
          this.KarakteristikYuzey4 = res.data[0].Yuzey4;

        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _KarakteristikModal() {
      this.KarakteristikModelDurum = true;
      this.KarakteristikModal = !this.KarakteristikModal;
      if (this.KarakteristikModal === true) {
        this.ResetForm();
      }
    },
    handleClick() {
      if (this._FormCheck()) { return; }

      let data = {
        Karakteristik_rowid: this.Karakteristik_rowid,
        Ad: this.KarakteristikAd,
        En: this.KarakteristikEn,
        Boy: this.KarakteristikBoy,
        Yukseklik: this.KarakteristikYukseklik,
        Derinlik: this.KarakteristikDerinlik,
        Renk: this.KarakteristikRenk,
        Ambalaj: this.KarakteristikAmbalaj,
        Ithal: this.KarakteristikIthal,
        Yuzey1: this.KarakteristikYuzey1,
        Yuzey2: this.KarakteristikYuzey2,
        Yuzey3: this.KarakteristikYuzey3,
        Yuzey4: this.KarakteristikYuzey4,
      };
      if (this.KarakteristikModelDurum) {
        // Yeni KArakteristik
        GlobalServis.GlobalServis("POST", "SetKarakteristik", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Karakteristik oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            this._KarakteristikModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });

      } else {
        // Edit Karakteristik
        GlobalServis.GlobalServis("POST", "UpdateKarakteristik", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Karakteristik düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._KarakteristikModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      }
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    ResetForm() {
      this.Karakteristik_rowid = null;
      this.KarakteristikAd = "";
      this.KarakteristikEn = 0;
      this.KarakteristikBoy = 0;
      this.KarakteristikYukseklik = 0;
      this.KarakteristikDerinlik = 0;
      this.KarakteristikRenk = "";
      this.KarakteristikAmbalaj = "";
      this.KarakteristikIthal = false;
      this.KarakteristikYuzey1 = "";
      this.KarakteristikYuzey2 = "";
      this.KarakteristikYuzey3 = "";
      this.KarakteristikYuzey4 = "";
    },
    InitServis() {
      this._GetKarakteristikTablo()
    },
    _FormCheck() {
      let Check = false;
      if (this.KarakteristikAd === "") {
        this.Valid.KarakteristikAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Karakteristik adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.KarakteristikAd = false; Check = false; }

      return Check;
    },
    _GetKarakteristikTablo() {
      GlobalServis.GlobalServis("GET", "GetKarakteristikTablosu", "").then((res) => {
        if (res.status == 200) {
          this.KarakteristikListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    infoGoster() {
      this.$toast.add({ severity: 'contrast', summary: 'Yapım Aşamasında', detail: 'Teknik Dokümanlar üzerinde çalışıyoruz.', life: 3000 });
    }
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
};
</script>